// Auth service — thin wrapper around /api/auth/* + /api/user/saved/*.

import { request } from "./httpAdapter";

// ─── Sprint 25 base flows ─────────────────────────────────────────
export const login = (email, password, rememberMe = false) =>
  request("/auth/login", {
    method: "POST",
    body: { email, password, remember_me: rememberMe },
  });

export const logout = () => request("/auth/logout", { method: "POST" });

export const me = (opts) => request("/auth/me", opts);

export const refresh = () => request("/auth/refresh", { method: "POST" });

export const forgotPassword = (email, turnstileToken = "") =>
  request("/auth/forgot-password", {
    method: "POST",
    body: { email, turnstile_token: turnstileToken || null },
  });

export const resetPassword = (token, newPassword) =>
  request("/auth/reset-password", {
    method: "POST",
    body: { token, new_password: newPassword },
  });

// ─── Sprint 28b extensions ────────────────────────────────────────
export const register = (email, password, fullName, turnstileToken = "") =>
  request("/auth/register", {
    method: "POST",
    body: { email, password, full_name: fullName, turnstile_token: turnstileToken || null },
  });

export const verifyEmail = (token) =>
  request("/auth/verify-email", { method: "POST", body: { token } });

export const resendVerification = () =>
  request("/auth/resend-verification", { method: "POST" });

export const changePassword = (currentPassword, newPassword) =>
  request("/auth/change-password", {
    method: "POST",
    body: { current_password: currentPassword, new_password: newPassword },
  });

export const updateProfile = ({ fullName, preferredCountry, preferredIndustries }) =>
  request("/auth/profile", {
    method: "PATCH",
    body: {
      full_name: fullName,
      preferred_country: preferredCountry,
      preferred_industries: preferredIndustries,
    },
  });

// ─── Saved opportunities (server-side, per user) ─────────────────
export const listSaved = () => request("/user/saved");
export const addSaved = (publicId) =>
  request(`/user/saved/${encodeURIComponent(publicId)}`, { method: "POST" });
export const removeSaved = (publicId) =>
  request(`/user/saved/${encodeURIComponent(publicId)}`, { method: "DELETE" });
export const backfillSaved = (publicIds) =>
  request("/user/saved/backfill", { method: "POST", body: { public_ids: publicIds } });
